export const PAYMENT_METHODS_FOR_BOOKING = {
  MEMBERSHIP: '1',
  CREDIT_CARD: '2',
};

export const MEMBERSHIP_FLIGHT_REQUEST = {
  SUCCESS: 0,
  UNEXPECTED: 1,
  NO_FUNDS: 2,
};